import { Actor } from './actor';

// Turn manager class
export class TurnManager {
  private actors: Actor[] = [];
  private currentActorIndex: number = 0;
  private onRoundComplete: (() => void) | null = null;

  constructor(actors: Actor[], onRoundComplete?: () => void) {
    this.actors = actors;
    this.onRoundComplete = onRoundComplete || null;
  }

  public getCurrentActor(): Actor {
    return this.actors[this.currentActorIndex];
  }

  public nextActor(): Actor | null {
    this.currentActorIndex = (this.currentActorIndex + 1) % this.actors.length;

    // If we've completed a full round, reset action points
    if (this.currentActorIndex === 0) {
      this.resetAllActionPoints();

      // Call the round complete callback if provided
      if (this.onRoundComplete) {
        this.onRoundComplete();
      }
    }

    return this.getCurrentActor();
  }

  private resetAllActionPoints() {
    for (const actor of this.actors) {
      actor.resetActionPoints();
    }
  }

  // Update our actors list (to remove defeated units)
  public updateActors(actors: Actor[]) {
    // Preserve the current actor index if possible
    const currentActor = this.actors[this.currentActorIndex];
    this.actors = actors;

    // Find the current actor in the new list
    const newIndex = this.actors.indexOf(currentActor);
    if (newIndex !== -1) {
      this.currentActorIndex = newIndex;
    } else {
      // If current actor was removed, keep the same index but cap at max
      this.currentActorIndex = Math.min(this.currentActorIndex, this.actors.length - 1);
    }
  }
}